/* eslint-disable react/no-array-index-key */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getPersonalInfo, getPartnerChildrens, setSelectedPartnerChildren } from 'actions/personalInfo'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import EditPersonalInfo from 'containers/EditPersonalInfo'
import PartnerChildrenForm from 'containers/PartnerChildrenForm'
import { modalShow, modalHide } from 'actions/modals'
import { deletePartnerChildren } from 'actions/partnerChildrenForm'
import BackToAdminCentre from 'components/BackToAdminCentre'
import { hasAccess } from 'utils/hasAccess'
import { commonFunctions } from 'utils/CommonFunctions'
import { headerTitleName } from 'utils/headerTitleName'
import { getEmployeeId } from 'utils/getEmployeeId'

class PersonalInfo extends Component {
  static propTypes = {
    deletePartnerChildren: PropTypes.func.isRequired,
    getPartnerChildrens: PropTypes.func.isRequired,
    getPersonalInfo: PropTypes.func.isRequired,
    personalInfo: PropTypes.object.isRequired,
    routes: PropTypes.instanceOf(Array),
    setErrorMessage: PropTypes.func.isRequired,
    selectedPartnerChildren: PropTypes.object,
  }
  componentDidMount() {
    // this.props.getPersonalInfo((this.props.selectedPartner.EmployeeId && this.props.currentUser.IsAdmin ? this.props.selectedPartner.EmployeeId : this.props.currentUser.EmployeeId))
    this.props.getPersonalInfo(getEmployeeId(this.props.selectedPartner, this.props.currentUser))
    this.props.getPartnerChildrens(getEmployeeId(this.props.selectedPartner, this.props.currentUser))
  }

  openEditPersonalInfoView = () => {
    this.props.modalShow('EditPersonalInfo')
  }

  handleDeletePartnerChildren = (id) => {
    const formData = {
      employee_id: getEmployeeId(this.props.selectedPartner, this.props.currentUser),
      loginname: '',
      id: (id || ''),
    }
    if (id) {
      this.props.deletePartnerChildren(formData)
    }
  }

  handleGetPartnerChildrens = () => {
    this.props.getPartnerChildrens(getEmployeeId(this.props.selectedPartner, this.props.currentUser))
  }

  handleOpenPartnerChildrenForm = (selectedPartnerChildren) => {
    this.props.setSelectedPartnerChildren(selectedPartnerChildren)
    this.props.modalShow('partnerChildrenForm')
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: headerTitleName(this.props.currentUser, 'Personal Info'),
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const { routes } = this.props
    let showEdit = false
    if (this.props.currentUser.IsAdmin && window.location.href.indexOf('admin/') > -1) {
      showEdit = hasAccess(this.props.currentUser, 'Personal Info', this.props.history, 'RW', false)
    }
    return (
      <div>
        <MainLayout
          bannerNavProps={{ ...this.bannerProps() }}
          partnerSideBarInfo={commonFunctions.checkPartnerSideBar(this.props)}
        >
          <BackToAdminCentre displayText={`${this.props.selectedPartner.Name}: Personal info`} isAdmin={this.props.currentUser.IsAdmin} />
          <Container>
            {routes.map((route, i) => (
              <RouteWithSubRoutes
                key={i}
                {...route}
                currentUser={this.props.currentUser}
                deletePartnerChildren={this.handleDeletePartnerChildren}
                getPartnerChildrens={this.handleGetPartnerChildrens}
                getPersonalInfo={this.props.getPersonalInfo}
                openEditPersonalInfoView={this.openEditPersonalInfoView}
                openPartnerChildrenForm={this.handleOpenPartnerChildrenForm}
                personalInfo={this.props.personalInfo}
                setErrorMessage={this.props.setErrorMessage}
                showEditLink={showEdit}
              />
            ))}
          </Container>
          {(showEdit ?
            <PartnerChildrenForm
              currentUser={this.props.currentUser}
              hide={this.props.modalHide}
              personalInfo={this.props.personalInfo}
            /> : '')}
          {(showEdit ?
            <EditPersonalInfo
              hide={this.props.modalHide}
              personalInfo={this.props.personalInfo}
            /> : '')}

        </MainLayout>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  personalInfo: state.personalInfo,
  // selectedPartner: state.personalinfos.selectedPartner,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  modalShow,
  modalHide,
  getPersonalInfo,
  getPartnerChildrens,
  deletePartnerChildren,
  setSelectedPartnerChildren,
})(PersonalInfo))



// WEBPACK FOOTER //
// ./src/containers/PersonalInfo.js